export const ethereumPaymentSectionUrl = '/nft/wallet/' as const;
export const nftFaqUrl = '/info/nft-faq/' as const;
